import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RepFinanzasModule } from './rep-finanzas/rep-finanzas.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RepFinanzasModule
  ],
  exports: [
    RepFinanzasModule
  ]
})
export class ReportesModule { }
